import "./CreationsGallery.module.css";
import Intestazione from "@/reusable_sections/Header";
import LArteInPasticceria from "./sections/LArteInPasticceria";
import RequestQuoteSection from "./sections/RequestQuoteSection";
import ProjectGallery from "./sections/ProjectGallery";
import PieDiPagina from "@/reusable_sections/Footer";
export default function CreationsGalleryPage() {
  return <div>
      <Intestazione />
      <LArteInPasticceria />
      <ProjectGallery />
      <RequestQuoteSection />
      <PieDiPagina />
    </div>;
}